module.exports = {"1":"Ungenügend","2":"Mangelhaft","3":"Akzeptabel","4":"Gut","5":"Hervorragend","1.5":"Ungenügend","2.5":"Mangelhaft","3.5":"Akzeptabel","4.5":"Hervorragend"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/de-CH/star-ratings.json
// module id = 1287
// module chunks = 0